import { Theme } from '@mui/material/styles';

export const styles = {
  paperContainer: (theme: Theme) => ({
    width: '100%',
    padding: theme.spacing(3),
  }),
  fileName: (theme: Theme) => ({
    marginBottom: theme.spacing(4),
  }),
  selectContainer: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: `${theme.spacing(4)} ${theme.spacing(4)} 0`,
  }),
  select: (theme: Theme) => ({
    marginBottom: theme.spacing(4),
  }),
  selectGreen: (theme: Theme) => ({
    color: theme.palette.success.main,
  }),
  greenOnHover: (theme: Theme) => ({
    '&:hover': {
      color: theme.palette.success.main,
    },
  }),
  selectOrange: () => ({
    color: '#FFB81C',
  }),
  orangeOnHover: () => ({
    '&:hover': {
      color: '#FFB81C',
    },
  }),
  selectRed: (theme: Theme) => ({
    color: theme.palette.error.main,
  }),
  redOnHover: (theme: Theme) => ({
    '&:hover': {
      color: theme.palette.error.main,
    },
  }),
  selectYellow: (theme: Theme) => ({
    color: theme.palette.warning.main,
  }),
  yellowOnHover: (theme: Theme) => ({
    '&:hover': {
      color: theme.palette.warning.main,
    },
  }),
};
